module.exports = __webpack_public_path__ + "img/game.ef04bbd9.png";